import { Path, Svg } from "react-native-svg";
import { getToken } from "@tamagui/core";
import { jsx } from "react/jsx-runtime";
const SvgClose = ({ size = 24, color = "$contentPrimary", ...inProps }) => {
  const outProps = {};
  if (size && (outProps.width = size, outProps.height = size), color) {
    const colorToken = getToken(color, "color");
    outProps.color = colorToken;
  }
  const props = {
    viewBox: "0 0 24 24",
    ...inProps,
    ...outProps
  };
  return /* @__PURE__ */ jsx(Svg, { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...props, children: /* @__PURE__ */ jsx(
    Path,
    {
      fill: "currentColor",
      d: "m12 13.4-5.776 5.776a1.12 1.12 0 0 1-.825.324q-.501 0-.825-.324a1.12 1.12 0 0 1-.324-.825q0-.502.324-.825l5.776-5.776-5.776-5.776a1.12 1.12 0 0 1-.324-.825q0-.501.324-.825T5.4 4q.502 0 .825.324L12 10.1l5.776-5.776Q18.099 4 18.6 4q.501 0 .825.324t.324.825q0 .502-.324.825L13.65 11.75l5.776 5.776q.324.323.324.825 0 .501-.324.825a1.12 1.12 0 0 1-.825.324q-.502 0-.825-.324z"
    }
  ) });
};
var Close_default = SvgClose;
export {
  Close_default as default
};
